import { render, staticRenderFns } from "./GestionTurnos.vue?vue&type=template&id=b22f09be&scoped=true"
import script from "./GestionTurnos.vue?vue&type=script&lang=js"
export * from "./GestionTurnos.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnos.vue?vue&type=style&index=0&id=b22f09be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22f09be",
  null
  
)

export default component.exports